var render, staticRenderFns
import script from "./integral_goods_management.vue?vue&type=script&lang=js&"
export * from "./integral_goods_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0307e36b')) {
      api.createRecord('0307e36b', component.options)
    } else {
      api.reload('0307e36b', component.options)
    }
    
  }
}
component.options.__file = "found/views/mall/views/integral_mall_management/integral_goods_management/integral_goods_management.vue"
export default component.exports